export const isLastItem = (arr, index) => arr.length - 1 === index;
